// @internal
export function isFunction(value) {
  return typeof value === 'function';
}
